import { render, staticRenderFns } from "./InputEdit.vue?vue&type=template&id=512659a0"
import script from "./InputEdit.vue?vue&type=script&lang=js"
export * from "./InputEdit.vue?vue&type=script&lang=js"
import style0 from "./InputEdit.vue?vue&type=style&index=0&id=512659a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports